import { mapUTMToCategory } from './utmCategoryMapping';

/**
 * Get referral source with fallback hierarchy
 * Captures UTM parameters, click IDs (gclid/fbclid), and referrer data
 *
 * @returns {Object} Referral data with source, medium, campaign, method, category, gclid, fbclid
 */
export function getReferralSource() {
  const urlParams = new URLSearchParams(window.location.search);

  // Capture click IDs for ad platform attribution (handles blank referrers)
  const gclid = urlParams.get('gclid') || ''; // Google Click ID
  const fbclid = urlParams.get('fbclid') || ''; // Meta/Facebook Click ID

  // Priority 1: Explicit UTM parameters
  if (urlParams.get('utm_source')) {
    const params = {
      source: urlParams.get('utm_source'),
      medium: urlParams.get('utm_medium') || '',
      campaign: urlParams.get('utm_campaign') || '',
      gclid,
      fbclid,
    };
    return {
      ...params,
      method: 'utm_params',
      category: mapUTMToCategory(params, 'utm_params')
    };
  }

  // Priority 2: Click ID detection (for blank referrers from ad platforms)
  if (gclid || fbclid) {
    const params = {
      source: '',
      medium: '',
      campaign: '',
      gclid,
      fbclid,
    };
    return {
      ...params,
      method: 'click_id',
      category: mapUTMToCategory(params, 'click_id')
    };
  }

  // Priority 3: Parse referrer URL
  if (document.referrer) {
    try {
      const referrerUrl = new URL(document.referrer);
      const hostname = referrerUrl.hostname;

      let params;
      // Map common referrers
      if (hostname.includes('facebook.com') || hostname.includes('fb.com')) {
        params = { source: 'facebook', medium: 'referral', campaign: '', gclid: '', fbclid: '' };
      } else if (hostname.includes('google.')) {
        params = { source: 'google', medium: 'organic', campaign: '', gclid: '', fbclid: '' };
      } else if (hostname.includes('instagram.com')) {
        params = { source: 'instagram', medium: 'referral', campaign: '', gclid: '', fbclid: '' };
      } else {
        params = { source: hostname, medium: 'referral', campaign: '', gclid: '', fbclid: '' };
      }
      return { ...params, method: 'referrer', category: mapUTMToCategory(params, 'referrer') };
    } catch {
      // Invalid referrer URL, fall through to direct
    }
  }

  // Priority 4: Direct/unknown
  const params = { source: 'direct', medium: 'none', campaign: '', gclid: '', fbclid: '' };
  return { ...params, method: 'unknown', category: mapUTMToCategory(params, 'unknown') };
}
